import { render } from "./BlogGrid.vue?vue&type=template&id=5fe8c86a"
import script from "./BlogGrid.vue?vue&type=script&lang=js"
export * from "./BlogGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__